import React, { useEffect, useState, useCallback, useMemo } from 'react';
import league from '../../../assets/icons/League.svg';
import tune from '../../../assets/icons/Tune.svg';
import okIcon from '../../../assets/icons/Ok.svg';
import { setMixSelectedLeagues, setBodySelectedLeagues} from '../../common/actions/common.actions';
import { useSelector, useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { MdOutlineTune } from "react-icons/md";
import { BsFillCheckCircleFill } from "react-icons/bs";

const FilterView = ({ onClose, leagues, onLeagueSelection, events, mixBody }) => {
  const dispatch = useDispatch();
  const { mixSelectedLeagues, bodySelectedLeagues  } = useSelector((state) => state.common);
  const [allLeaguesSelected, setAllLeaguesSelected] = useState(true);
  const isWideWindow = useMemo(() => window.innerWidth >= 1024, []);

  const setSelectedLeagueData = useCallback((data) => {
    mixBody === 'maung' ? dispatch(setMixSelectedLeagues(data)) : dispatch(setBodySelectedLeagues(data));
  }, [dispatch, mixBody]);

  useEffect(() => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    if (leagues && leagues.length > 0 && selectedLeagues && selectedLeagues.length > 0) {
      const leagueNames = leagues.map((league) => league.leagueName);

      const isSelectAll =
        leagueNames.every((leagueName) => selectedLeagues.includes(leagueName)) &&
        selectedLeagues.every((leagueName) => leagueNames.includes(leagueName));
      if (isSelectAll === true) {
        setAllLeaguesSelected(true);
      } else {
        setAllLeaguesSelected(false);
      }
      setSelectedLeagueData(selectedLeagues);
    }
  }, [leagues, mixBody, mixSelectedLeagues, bodySelectedLeagues, setSelectedLeagueData]);
  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleCheckboxChange = (leagueName) => {
    if (allLeaguesSelected) {
      const updatedLeagues = leagues.reduce((acc, league) => {
        if (league.leagueName !== leagueName) {
          acc.push(league.leagueName);
        }
        return acc;
      }, []);
      setSelectedLeagueData(updatedLeagues);
      setAllLeaguesSelected(false);
    } else {
      const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
      setSelectedLeagueData(selectedLeagues.includes(leagueName)
          ? selectedLeagues.filter((name) => name !== leagueName)
          : [...selectedLeagues, leagueName]
      );
    }
  };

  useEffect(()=>{
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    if (selectedLeagues && leagues && leagues.length === selectedLeagues.length) {
      setAllLeaguesSelected(true);
    }
  },[mixSelectedLeagues, bodySelectedLeagues, leagues, mixBody])

  const handleOKClick = () => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    handleSongClick();
    const selection = allLeaguesSelected
      ? leagues.map((league) => league.leagueName)
      : selectedLeagues;
    onLeagueSelection(selection);
    setSelectedLeagueData(selection);
    onClose();
  };

  const handleAllSelectedChange = () => {
    setSelectedLeagueData([]);
  };



  return (
    <div className="py-1 text-bg_header overflow-auto h-[100dvh] backdrop-blur-xl transform transition-transform shadow-lg">
      <div className={`flex px-2 fixed top-0 w-full h-[90px] justify-between ${isWideWindow ? 'max-w-7xl' : ''} items-center text-center bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl border-b-2 border-crimson/40 shadow-2xl`}>
        <div className="flex justify-center items-center">
          <div className="w-8 h-8 bg-gradient-to-br from-crimson via-red-primary to-crimson rounded-lg flex items-center justify-center shadow-md mr-2 border border-golden/40">
            <MdOutlineTune size={18} className='text-white' />
          </div>
          <h2 className="text-lg text-blue-primary font-bold">
            {leagues.length} League / {events} Events
          </h2>
        </div>
        <button className="flex items-center px-4 py-2 bg-gradient-to-br from-crimson via-red-primary to-crimson rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-golden/40" onClick={handleOKClick}>
          <BsFillCheckCircleFill size={18} className="text-white" />
          <label
            htmlFor="checked-checkbox"
            className="ml-2 text-sm font-bold text-white cursor-pointer"
          >
            OK
          </label>
        </button>
        {/* Luxury Border Accent */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-crimson via-golden to-crimson shadow-lg"></div>
      </div>
      <div className="container px-5 mt-20 h-12 flex items-center bg-white/50 rounded-xl mx-auto shadow-md border border-crimson/20">
        <input
          id="filter-checkbox"
          type="checkbox"
          checked={allLeaguesSelected}
          value=""
          className="w-4 h-4 text-crimson bg-white border-crimson/30 focus:ring-crimson focus:ring-2 rounded cursor-pointer"
          onClick={() => setAllLeaguesSelected(!allLeaguesSelected)}
          onChange={handleAllSelectedChange}
        />
        <label
          htmlFor="filter-checkbox"
          className="ml-2 text-sm font-bold text-blue-primary cursor-pointer"
        >
          {allLeaguesSelected ? 'Deselect All' : 'Select All'}
        </label>
      </div>
      <ul className='mt-2 mb-2 overflow-y-scroll h-[80vh]'>
        {leagues &&
          leagues.map((league, index) => (
            <li
              className={`${index % 2 === 0 ? 'bg-white/30' : 'bg-transparent'
                } z-40 w-full flex items-center px-10 h-[52px] hover:bg-crimson/5 transition-colors duration-200`}
              key={league.leagueId || index}
            >
              <div>
                <input
                  id={`filter-checkbox-${league.leagueId}`}
                  type="checkbox"
                  value=""
                  className="w-4 h-4 text-crimson bg-white border-crimson/30 focus:ring-crimson focus:ring-2 rounded cursor-pointer"
                  onChange={() => handleCheckboxChange(league.leagueName)}
                  checked={
                    allLeaguesSelected ||
                    ((mixBody === 'maung' && mixSelectedLeagues.length > 0 && mixSelectedLeagues.includes(league.leagueName)) ||
                    (mixBody !== 'maung' && bodySelectedLeagues.length > 0 && bodySelectedLeagues.includes(league.leagueName)))
                  }
                />
                <label
                  htmlFor={`filter-checkbox-${league.leagueId}`}
                  className="ml-2 text-sm font-medium text-blue-primary cursor-pointer"
                >
                  {league.leagueName}
                </label>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default FilterView;
